import React from 'react';

export const SuspenseWrapper = ({ children }) => (
  <React.Suspense fallback={null}>{children}</React.Suspense>
);
